import Cookies from 'js-cookie'
import { config } from '@/clients/auth0/config'
import { verifyJWK } from './jwk-verify'

const { cookieName } = config

export type GetVerifiedUserIdFunction = () => Promise<string | null>

export const getVerifiedUserId: GetVerifiedUserIdFunction = async () => {
  try {
    const cookie = Cookies.get(cookieName)
    if (!cookie) return null

    const parsed = JSON.parse(cookie)
    if (!parsed || typeof parsed !== 'object') return null

    const { id_token } = parsed
    if (!id_token || typeof id_token !== 'string') return null

    const { payload } = (await verifyJWK(id_token)) || {}
    return payload?.sub ?? null
  } catch (error) {
    console.error('Error getting verified user ID:', error)
    return null
  }
}
